import { render } from "./index.vue?vue&type=template&id=1228d2cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=1228d2cc&scoped=true&lang=less"
import "./index.vue?vue&type=style&index=1&id=1228d2cc&lang=less"

import exportComponent from "/Users/zhanghao/Documents/beijing/maidong/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1228d2cc"]])

export default __exports__